import * as React from "react"
import {useSignal} from "@preact/signals-react";
import {Box} from "@mui/material";
import { AlertSeeker } from "@components/ui"


export default function AppWrapperPageNotificationsGroupedBlock({ title='', open=false, children, ...config }) {

	const isOpen = useSignal(open)

	return <Box sx={{ width: 1, py: 1 }}>
		<AlertSeeker
			title={title}
			isOpen={isOpen.value}
			severity="warning"
			controller={() => isOpen.value = !isOpen.value}
			{...config}
		>
			{children}
		</AlertSeeker>
	</Box>
}